///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.checkbooks = abcsetup.promos.checkbooks || {};
abcsetup.promos.checkbooks.edit = abcsetup.promos.checkbooks.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks.edit = {
    init() {
        abcsetup.setTitle('Promotional Checkbook');

        this._setupAddPromoModal();
        this._setupSyncSupplierDeductButton();
        this._setupRemoveButtons();
        this._setupIgnoreFields();
        this._setupValidatePromoButtons();
        this._setupValidateAllButton();
        this._setupBillingAmountTotalUpdates();

        $(() => this._updateBillingAmountTotals());

        abcsetup.promos.checkbooks.setupPromoSupplierItemsModal();
        abcsetup.promos.checkbooks.setupAccordions();
    },

    /**
     * Add a promo to the checkbook.
     *
     * @param promo_checkbook_id
     * @param promo
     */
    _addPromo(promo_checkbook_id, promo) {
        abcsetup.blockUI(true);

        const template = $('.promo-accordion-template').children().clone();

        const formatDate = date => moment(date).tz('UTC').format('MMM D, YYYY');

        template.find('.card-header').children().first().attr('data-target', `#promo_${promo.id}`);
        template.find('.collapse').attr('id', `promo_${promo.id}`);
        template.find('.promo_name').text(promo.name);
        template.find('.promo_active_dates').text(`${formatDate(promo.start_run)} - ${formatDate(promo.end_run)}`);
        template.find('.promo_vendor_window').text(promo.vendor_window[0].toUpperCase() + promo.vendor_window.slice(1));
        template.find('.remove-btn').attr('data-promo-id', promo.id);

        const promos_list = $('#promos-list');
        promos_list
            .append(template)
            .find('.collapse')
            .collapse({toggle: false});

        this._setupRemoveButtons();
        abcsetup.promos.checkbooks.setupAccordions();

        $('#add-promos-alert').toggle(promos_list.children().length === 0);

        axios.post(`/api/promos/checkbooks/${promo_checkbook_id}/promos/${promo.id}`)
            .then(response => {
                template.find('.entries-table-container').html(response.data.html);
                this._updateBillingAmountTotals();
                abcsetup.unblockUI();
            });
    },

    /**
     * Add the ability to remove a promo from the checkbook.
     *
     * @private
     */
    _setupRemoveButtons() {
        $(document).on('click', '.promo-accordion .remove-btn', e => {
            e.preventDefault();
            e.stopPropagation();

            abcsetup.alerts.confirm(
                'Remove Promo?',
                `Are you sure you'd like to remove this promo?`,
                confirmed => {
                    if (confirmed) {
                        $(e.target).closest('.promo-accordion').remove();
                        $('#add-promos-alert').toggle($('#promos-list').children().length === 0);
                        this._updateBillingAmountTotals();
                        axios.delete(`/api/promos/checkbooks/${$('[name=promo_checkbook_id]').val()}/promos/${e.target.dataset.promoId}`)
                    }
                }
            );
        })
    },

    /**
     * Make the supplier row translucent if they're set to "ignore" for that promo.
     * Also, if ignore = "Y", then billing amount is zero.
     * If ignore = "N", then billing amount is reset to original amount.
     *
     * @private
     */
    _setupIgnoreFields() {
        const toggleTranslucent = (field, on) => $(field).closest('tr')
            .toggleClass('translucent', on);
        const updatePreviousValue = field => $(field).data('previousValue', String($(field).val()));
        const updateBillingAmount = (row, newAmount) => $(row).find('.field-billing_amount')
            .val(newAmount);

        $(':input.field-ignore')
            .each((idx, el) => {
                toggleTranslucent(el, String($(el).val()) === '1');
                updatePreviousValue(el);
            });

        $(document).on('change', ':input.field-ignore', e => {
            const field = e.target;
            const value = String($(field).val());
            const isIgnore = value === '1';

            toggleTranslucent(field, isIgnore);

            if (isIgnore) {
                updateBillingAmount($(field).closest('tr'), 0);
            } else if ($(field).data('previousValue') === '1') {
                updateBillingAmount(
                    $(field).closest('tr'),
                    $(field).closest('tr').find('.field-original_billing_amount').val()
                );
            }

            updatePreviousValue(field);
        });
    },

    /**
     * Update supplier deduct from allowance dropdown selections so they match the global settings.
     *
     * @private
     */
    _setupSyncSupplierDeductButton() {
        $('#sync-supplier-deduct').on('click', () => {
            abcsetup.blockUI(true);

            const OrgInputs = $('.promo-accordion:visible :input.field-org_id').toArray();
            const vendorIds = OrgInputs.map(OrgInput => $(OrgInput).val());

            axios.get('/api/promos/checkbooks/supplier_deductions?vendor_ids=' + _.uniq(vendorIds).join(','))
                .then(response => {
                    OrgInputs.forEach(OrgInput => {
                        const org_id = $(OrgInput).val();

                        if (response.data.deduct_settings.hasOwnProperty(org_id)) {
                            $(OrgInput).closest('tr')
                                .find('.field-deduct_from_promo_allowance')
                                .val(Number(response.data.deduct_settings[org_id]));
                        }
                    });

                    abcsetup.unblockUI();
                    abcsetup.alerts.show(
                        'Synced Supplier Deduct Values',
                        '"Deduct From Promotional Balance" field values have been synchronized with global settings.'
                    );
                });
        });
    },

    /**
     * Pop up a modal and ask which promo we should add.
     *
     * @private
     */
    _setupAddPromoModal() {
        $('#add-promo-btn').on('click', () => this._showAddPromoModal());
    },

    /**
     * Show the Add Promo modal.
     *
     * @private
     */
    _showAddPromoModal() {
        const Modal = $('#promos-checkbooks-add-promo-modal');
        Modal.modal('show');

        Modal.find('.btn-primary').on('click', () => {
            const selectedPromos = Modal.find('select.select2').select2('data');

            if (!Array.isArray(selectedPromos) || selectedPromos.length === 0) {
                return;
            }

            selectedPromos.forEach(selectedPromo =>
                this._addPromo($('[name=promo_checkbook_id]').val(), selectedPromo)
            );

            Modal.find('select.select2').val(null).trigger('change');
            Modal.modal('hide');
        });
    },

    /**
     * Allow users to validate fields within a Promo's accordion.
     *
     * @private
     */
    _setupValidatePromoButtons() {
        $(document).on('click', '.promo-accordion .validate-entries-btn', e => {
            this._validatePromo($(e.target).closest('.promo-accordion'));
        });
    },

    /**
     * Validate a promo.
     *
     * @param {jQuery|HTMLElement} PromoAccordion
     * @private
     */
    _validatePromo(PromoAccordion) {
        if (fieldValidate.checkValidity($(PromoAccordion).find(':input:not(:disabled)'))) {
            this._markPromoValid(PromoAccordion)
        } else {
            this._markPromoInvalid(PromoAccordion);
        }
    },

    /**
     * Mark a promo as valid.
     *
     * @param {jQuery|HTMLElement} PromoAccordion
     * @private
     */
    _markPromoValid(PromoAccordion) {
        PromoAccordion = $(PromoAccordion);
        PromoAccordion.find('.card-header')
            .removeClass('list-group-item-danger')
            .addClass('list-group-item-success');

        const ValidateButton = PromoAccordion.find('.validate-entries-btn');
        ValidateButton
            .removeClass('btn-info')
            .removeClass('btn-danger')
            .addClass('btn-success');

        window.setTimeout(
            () => ValidateButton.removeClass('btn-success').removeClass('btn-danger').addClass('btn-info'),
            2000
        );
    },

    /**
     * Mark a promo as invalid.
     *
     * @param {jQuery|HTMLElement} PromoAccordion
     * @private
     */
    _markPromoInvalid(PromoAccordion) {
        PromoAccordion = $(PromoAccordion);
        PromoAccordion.find('.card-header')
            .removeClass('list-group-item-success')
            .addClass('list-group-item-danger');

        const ValidateButton = PromoAccordion.find('.validate-entries-btn');
        ValidateButton
            .removeClass('btn-info')
            .removeClass('btn-success')
            .addClass('btn-danger');

        window.setTimeout(
            () => ValidateButton.removeClass('btn-success').removeClass('btn-danger').addClass('btn-info'),
            2000
        );
    },

    /**
     * All users to validate all the promos.
     *
     * @private
     */
    _setupValidateAllButton() {
        $('#validate-all-btn').on('click', () => {
            $('#checkbooks-form .promo-accordion').each((idx, el) => this._validatePromo(el));
        });
    },

    /**
     * When a billing amount changes, update the billing amount totals.
     *
     * @private
     */
    _setupBillingAmountTotalUpdates() {
        this._updateBillingAmountTotals();

        $(document).on(
            'keyup',
            '.promo-accordion:visible :input.field-billing_amount',
            () => this._updateBillingAmountTotals()
        );
        $(document).on(
            'change',
            '.promo-accordion:visible :input.field-billing_amount',
            () => this._updateBillingAmountTotals()
        );
    },

    /**
     * Update the billing amount totals for promos and for the entire checkbook based on the data currently in the form.
     *
     * @private
     */
    _updateBillingAmountTotals() {
        // Using something like https://mathjs.org/ is better for math with floating-point numbers than plain-old JS.
        const total = $('.promo-accordion:visible').toArray().reduce((total, accordion) => {
            const promoTotal = $(accordion).find(':input.field-billing_amount').toArray()
                .reduce((promoTotal, amountField) => promoTotal + Number($(amountField).val()), 0);

            $(accordion).find('.promo_total').text(abcsetup.formatter.currency(promoTotal));

            return total + promoTotal;
        }, 0);

        $('#checkbook_total').text(abcsetup.formatter.currency(total));
    },

    /**
     * This is a system-wide hook that's triggered when a field is invalid.
     */
    fieldError() {
        this._markPromoInvalid($('#checkbooks-form .promo-accordion:has(.errorMsg)'));
    },
}
